/**
 * Parses match_date (RFC3339 string) directly to avoid local timezone conversion.
 * Format: 2024-04-21T20:33:00+08:00
 */

/**
 * Returns HH:mm
 */
export function parseMatchTime(dateStr) {
  if (!dateStr) return '—'
  // RFC3339 expected: YYYY-MM-DDTHH:mm:ss...
  const parts = dateStr.split('T')
  if (parts.length < 2) return '—'
  return parts[1].substring(0, 5) // "15:04"
}

/**
 * Returns MM/DD
 */
export function parseMatchDate(dateStr) {
  if (!dateStr) return ''
  const datePart = dateStr.split('T')[0]
  const parts = datePart.split('-') // YYYY-MM-DD
  if (parts.length < 3) return ''
  return `${parseInt(parts[1])}/${parseInt(parts[2])}` // M/D
}
